import { z } from 'zod';
import { isoDateSchema } from '../shared/firestore-timestamp.schema.js';
const sourceSchema = z.enum(['IP', 'GPS', 'MANUAL']);
const timestampInputSchema = z.preprocess((value) => (value instanceof Date ? value.toISOString() : value), isoDateSchema.optional());
const locationFields = {
    country: z.string().trim().min(1),
    city: z.string().trim().min(1),
    latitude: z.number().finite(),
    longitude: z.number().finite(),
    source: sourceSchema,
    timestamp: timestampInputSchema,
    confidence: z.number().min(0).max(100),
};
const canonicalLocationSchema = z
    .object({
    ...locationFields,
    countryCode: z.string().regex(/^[A-Za-z]{2}$/),
})
    .strict();
const ipLocationSchema = z
    .object({
    ...locationFields,
    country_code: z.string().regex(/^[A-Za-z]{2}$/),
    timezone: z.string().optional(),
    continent_code: z.string().optional(),
})
    .strict();
/**
 * Compatibilité legacy à l'entrée : accepte les deux formes historiques du
 * formulaire et produit exclusivement la forme canonique persistable.
 */
export const userLocationInputSchema = z
    .union([canonicalLocationSchema, ipLocationSchema])
    .transform((location) => ({
    country: location.country,
    countryCode: ('countryCode' in location
        ? location.countryCode
        : location.country_code).toUpperCase(),
    city: location.city,
    latitude: location.latitude,
    longitude: location.longitude,
    source: location.source,
    ...(location.timestamp && { timestamp: location.timestamp }),
    confidence: location.confidence,
}));
